import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import UserAgreement from "../pages/user-agreement/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import AppLandingRedirect from "../pages/app/page";
import AppLandingV2Redirect from "../pages/app/v2";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/user-agreement",
    element: <UserAgreement />,
  },
  {
    path: "/app",
    element: <AppLandingRedirect />,
  },
  {
    path: "/app/v2",
    element: <AppLandingV2Redirect />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
